/*
 * @Descripttion:
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-04-02 11:18:23
 */
import React, { useState, useEffect, useRef } from 'react';
import { message, Table, Button } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import LayoutHead from '../personal-center/components/header';
import NoData from '@/components/no-data';
import CarouselComponent from '@/components/like-carousel';
import useBackToTop from '@/hooks/useBackToTop';
import { setCartCount } from '@/features/user/userSlice';
import { orderCountTotal } from '@/api/personal-center';
import DeleteModal from '../personal-center/components/delete-modal';
import { getCartList, deleteCartGoods, clearInvalidGoods, settleAccountsGoods } from '../../api/shopping';
import './index.scss';
import { dispatch } from '@/redux/store';
import { useNavigate } from 'react-router-dom';
export interface DataType {
  key: React.Key;
  id: number,
  productName: string;
  model: string;
  price: string;
  quantity: number;
  subtotal: string;
  pmsFiles: any;
  valid: number;
  onLine: number;
  productSn: string;
}
const ShoppingCart: React.FC = () => {
  const navigate = useNavigate();
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const containerRef = useRef<HTMLDivElement>(null);
  const introRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);
  const [shoppingList, setShoppingList] = useState<DataType[]>([]);
  const [goodsDeleteModal, setGoodsDeleteModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [shoppingData, setShoppingData] = useState<any>(null); // 购物车信息
  const [selectRowList, setSelectRowList] = useState<DataType[]>([]); // 勾选商品
  const [deleteStatus, setDeleteStatus] = useState(0); // 0删除，1清空
  const [totalSum, setTotalSum] = useState(0); // 合计金额
  const [isValid, setIsValid] = useState(false); // 是否有失效商品
  const [cartIdsArr, setCartIdsArr] = useState<React.Key[]>([]); // 删除商品的id
  const deleteDialogText = [
    {
      title: '删除商品',
      content: '确定要删除商品吗？'
    },
    {
      title: '清空失效商品',
      content: '请确认是否清空已失效商品信息'
    },
    {
      title: '删除商品',
      content: '确定要删除商品吗？'
    }
  ]
  const shoppingColumns: TableColumnsType<DataType> = [
    {
      title: '全选',
      dataIndex: 'all',
      width: 70,
      className: 'select-name',
      render: (text: string, record: DataType) => <>{(record.valid === 1 || record.onLine === 1) && <span className="valid-show">已失效</span>}</>,
    },
    {
      title: '商品',
      dataIndex: 'productName',
      width: 320,
      className: 'product-name',
      render: (text: string, record: DataType) => (
        <div className="name-show" title={text} onClick={()=>window.open(`/detail?productSn=${record.productSn}`)}>
          <img src={record?.pmsFiles[0]?.url} alt="" />
          {text}
        </div>
      ),
    },
    {
      title: '规格型号',
      dataIndex: 'model',
      width: 200,
      render: (text: string) => <div className="shop-style" title={text}>{text}</div>,
    },
    {
      title: '单价',
      dataIndex: 'price',
      render: (text: string) => <span>¥{text}</span>
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      width: 80,
    },
    {
      title: '小计',
      dataIndex: 'subtotal',
      render: (text: string, record: DataType) => <span className="subtotal-price">¥{(Number(record.price) * record.quantity).toFixed(2)}</span>,
    },
    {
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: DataType) => (
        <span className="operate-del" onClick={() => deleteGoodsFunc(0,record.id)}>
          删除
        </span>
      ),
    },
  ];
  useEffect(() => {
    scrollToTop();
    shoppingListFunc();
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const stickyElement = introRef.current;
    const stickyRect = stickyElement?.getBoundingClientRect();
    const introHeight = containerRef.current?.offsetHeight;
    if(stickyRect&&introHeight) {
      // 判断元素是否处于粘性状态
      if (scrollTop+stickyRect.top >= introHeight+160) {
        setIsSticky(false);
      } else {
        setIsSticky(true);
      }
    }
  };
  // 购物车列表
  const shoppingListFunc = () => {
    getCartList().then((gRes: any) => {
      if (gRes.success) {
        setShoppingData(gRes.obj);
        let getRes = [];
        getRes = gRes.obj?.productList.map((cRes: any) => {
          cRes.key = cRes.id;
          if(cRes.valid === 1 || cRes.onLine === 1) {
            setIsValid(true);
          }
          cRes.models?.forEach((mData: any) => {
            if (mData.type === 1) {
              cRes.model = mData.models;
              return;
            }
          });
          return cRes;
        });
        dispatch(setCartCount(gRes.obj?.productNumber??0));
        setShoppingList(getRes);

      }
    });
  };
  const rowSelection: TableProps<DataType>['rowSelection'] = {
    getCheckboxProps: (record) => ({
      disabled: record.valid === 1 || record.onLine === 1, // 根据 disabled 字段禁用选择框
    }),
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      let sum = 0;
      selectedRows.forEach((sData:DataType) => {
        sum += Number(sData.price) * sData.quantity;
      })
      setTotalSum(sum);
      setSelectedRowKeys(selectedRowKeys);
      setSelectRowList(selectedRows);
    },
  };
  // 获取购物车数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setCartCount(oRes.obj?.cartNum??0));
      }
    })
  }
  // 删除弹窗
  const deleteGoodsFunc = (flag:number,id?:number) => {
    setGoodsDeleteModal(true);
    setDeleteStatus(flag);
    if(id) {
      setCartIdsArr([id]);
    }else {
      setCartIdsArr([]);
    }

  };
  
  const goodsDeleteFunc = () => {
    if(deleteStatus === 1) {
      clearInvalidGoods().then((cRes:any) => {  // 清空失效商品
        if(cRes.success) {
          message.success('清空成功！');
          shoppingListFunc();
          cartCountFunc();
        }else{
          message.error(cRes.message);
        }
      })
    }else {
      const keyArr:React.Key[] = deleteStatus===0?cartIdsArr:selectedRowKeys;
      cartGoodsDelete(keyArr,0);
    }
    setGoodsDeleteModal(false);
  };
  // 批量移除
  const cartGoodsDelete = (keyArr:React.Key[],flag:number) => {
    const newSelectedRowKeys = selectedRowKeys.filter(selectedKey => !keyArr.includes(selectedKey));
    const newSelectRowList = selectRowList.filter(ele => !keyArr.includes(ele.id));
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectRowList(newSelectRowList);
    deleteCartGoods(keyArr).then((dRes:any) => { // 删除商品
      if(dRes.success) {
        if(flag === 0) {
          message.success('删除成功！');
          if(deleteStatus === 0) {
            let sum = 0;
            newSelectRowList.forEach((sData:any) => {
              // if(sData.id !== cartIdsArr[0]) {
                sum += Number(sData.price) * sData.quantity;
              // }
            })
            setTotalSum(sum);
          }else {
            setTotalSum(0);
          }
         
          shoppingListFunc();
          cartCountFunc();
        }
       
      }else{
        message.error(dRes.message);
      }
    })
  }
  // 跳转到结算
  const setCacheAndJump = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请先选择结算的商品');
      return
    }
    settleAccountsGoods(selectRowList).then((sRes:any) => {
      if(sRes.success) {
        // cartGoodsDelete(selectedRowKeys,1);
        navigate('/user/confirm');
      }else {
        message.error(sRes.message);
      }
    })
  };
  return (
    <div className="shopping-cart-main">
      <LayoutHead title="购物车结算"></LayoutHead>
      <div className="shopping-cart-content">
        <div className="all-product-table" ref={containerRef}>
          <div className="all-product-title">
            全部商品（{shoppingData?.productNumber ?? 0}）
            <Button disabled={!isValid} onClick={()=>deleteGoodsFunc(1)}>清空失效商品</Button>
            <Button disabled={selectedRowKeys.length===0} onClick={()=>deleteGoodsFunc(2)}>删除</Button>
          </div>
          {
            shoppingList?.length>0?
            <Table<DataType> 
              rowSelection={{ ...rowSelection }} 
              columns={shoppingColumns} 
              dataSource={shoppingList} 
              pagination={false} 
            />:
            <NoData title='暂无数据' />
          }
        </div>
        <div className={`${isSticky && 'sticky-show'} settlement-total`} ref={introRef}>
          <span>已选择 {selectedRowKeys.length}件 商品</span>
          <div className="total-operate">
            <span className="total-title">合计：</span>
            <mark>￥ {totalSum.toFixed(2)}</mark>
            <span className="settlement-btn" onClick={() => setCacheAndJump()}>
              去结算
            </span>
          </div>
        </div>
        <div className="look-recommend">
          <CarouselComponent mode="normal" />
        </div>
      </div>
      <DeleteModal 
        showDeleteModal={goodsDeleteModal} 
        setShowDeleteModal={setGoodsDeleteModal} 
        handleDelete={goodsDeleteFunc} 
        title={deleteDialogText[deleteStatus].title} 
        content={deleteDialogText[deleteStatus].content} 
      />
    </div>
  );
};

export default ShoppingCart;
